import { DateField } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { Box } from '@mui/material';

interface DateFieldProps {
  label: string;
  value?: Dayjs;
  format?: string;
  readOnly?: boolean;
}

const DateFieldComponent = ({
  label,
  value,
  readOnly,
  format,
  ...props
}: DateFieldProps) => {
  const isValidValue = value?.isValid?.() ?? false;

  return (
    <Box sx={{ width: '100%' }} mb={3}>
      <DateField
        {...props}
        readOnly={readOnly || false}
        value={isValidValue ? value : null}
        label={label}
        disabled={!isValidValue}
        format={format || 'DD/MM/YYYY HH:mm:ss'}
        fullWidth
        sx={{
          '& .MuiInputLabel-root.Mui-disabled': {
            color: 'gray',
          },
          '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: 'transparent',
            color: 'gray',
          },
          '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'gray',
            },
          '& .MuiInputBase-root.Mui-disabled input': {
            WebkitTextFillColor: 'gray',
          },
        }}
      />
    </Box>
  );
};

export default DateFieldComponent;
